import { connect } from "react-redux";
import RecordingComponent from "../Components/InitComponent";
import { setScope } from "../Redux/Actions/scopeActions";
import { setGroups } from "../Redux/Actions/groupsActions";
import { setCallFlows ,setCallFlowsIds} from "../Redux/Actions/callFlowsActions";
import { setSupervisedAgentDetails,setSupervisedAgentIds } from "../Redux/Actions/agentsActions";
import {setMyAgentProfile} from "../Redux/Actions/myAgentProfileActions"
const mapDispatchToProps = (dispatch) => ({
  setMyAgentProfile: (myAgent) => dispatch(setMyAgentProfile(myAgent)),
  setScope: (scope) => dispatch(setScope(scope)),
  setGroups: (groups) => dispatch(setGroups(groups)),
  setCallFlows: (callFlows) => dispatch(setCallFlows(callFlows)),
  setCallFlowsIds: (callFlowsIds) => dispatch(setCallFlowsIds(callFlowsIds)),
  setSupervisedAgentDetails: (supervisedAgentData) => dispatch(setSupervisedAgentDetails(supervisedAgentData)), 
  setSupervisedAgentIds: (SupervisedAgentIds) => dispatch(setSupervisedAgentIds(SupervisedAgentIds)),
});

export default connect(null, mapDispatchToProps)(RecordingComponent);
